export const NOTIFICATION_TEXT = {
  NO_MORE_BETS: 'NO_MORE_BETS',
  DEALING_TIME: 'DEALING_TIME',
};

export const BET_HISTORY = {
  BET_TYPE: 'BET_TYPE',
  BET: 'BET',
  WIN: 'WIN',
  RESULT: 'RESULT',
  TOTAL: 'TOTAL',
};

export const BACCARAT_STATISTICS_TYPES = {
  BIG_ROAD1: 'BIG_ROAD1',
  BIG_ROAD2: 'BIG_ROAD2',
  BIG_ROAD3: 'BIG_ROAD3',
};

export const BACCARAT = 'BACCARAT';

export const SOCKET_CONNECTION_ERROR_CODE = '1006';

export const IDS = [1, 2, 3, 4, 5, 6];

export const SHUFFLED_MESSAGE = 'CardResult';

export const ANIMATION_DURATION = 3000;

export const SHUFFLE_AND_BURNED_ANIMATION_DURATION = 14000;

export const SHUFFLE_CARDS_COUNT = new Array(45).fill(null).map((item, index) => index);

// game rules keys = 45
export const GAME_RULES_HELP_KEYS = new Array(27).fill(null).map((item, index) => index);
export const GAME_RULES_HELP_KEYS_TURBO = new Array(29).fill(null).map((item, index) => index);

export const SOCKET_METHODS = {
  TurboBetAccepted: 'TurboBetAccepted',
  ShuffleCards: 'ShuffleCards',
  CardResult: 'CardResult',
  GetBalanceResult: 'GetBalanceResult',
  GetBalance: 'GetBalance',
};

export const TURBO_GAME_ID = 141432;
export const BET_SHOP_GAME_ID = 59;

export const PASCAL_PLATFORM_ID = 18746949;
